<div class="content"
    *ngIf ="showSplash">
    <img class="imagen-inicio_1" src="./../assets/imagenes/icono2_sin_zz.png">
    <img class="imagen-inicio_2" src="./../assets/imagenes/icono2_z.png">
    <img class="imagen-inicio_3" src="./../assets/imagenes/icono2_zz.png">
</div>
